<script setup>
import { Cross } from '../Icons';

const photoArray = defineModel();

const convertImg = image => {
	return URL.createObjectURL(image);
}

const removeImage = image => {
	const index = photoArray.value.indexOf(image);
	
	if (index !== -1) 
		photoArray.value.splice(index, 1);
}
</script>

<template>
	<div class="photo-gallery-wr">
		<div class="photo-gallery__content">
			<div
				class="photo-gallery__item"
				v-for="item in photoArray"
			>
				<button class="remove-image" @click="removeImage(item)">
					<Cross />
				</button>
				<img :src="convertImg(item)" alt="">
			</div>
		</div>
	</div>
</template>

<style lang='scss'>
.photo-gallery-wr { width: 100% }

.photo-gallery__content {
	width: fit-content;
	display: flex;
	gap: 20px;
}

.photo-gallery__item {
	width: 62px;
	height: 62px;
	position: relative;
	border-radius: 8px;
	overflow: hidden;

	&:hover {
		.remove-image { display: flex }
	}

	.remove-image {
		width: 100%;
		height: 100%;
		position: absolute;
		display: none;
		background-color: #42424299;

		svg { margin: auto }
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
</style>